import { type Vertex, type IDFSVisitor, type AdjacencyList, ESearchDirection } from './AdjacencyList';

export class NotDAGError extends Error {
  public constructor(vFrom: Vertex, vTo: Vertex) {
    super('The graph must be a DAG.' + '\n  Back edge detected: ' + vFrom + ' -> ' + vTo);
    Object.setPrototypeOf(this, NotDAGError.prototype);
  }
}

// Direct acyclic graph test visitor.
//
// Throws an exception if back edge is detected.
//
// A directed graph is a DAG if and only if it can be topologically ordered,
// by arranging the vertices as a linear ordering that is consistent with all
// edge directions.
//
class _DFSCircleDetector implements IDFSVisitor {
  public backEdge(vFrom: Vertex, vTo: Vertex): void {
    throw new NotDAGError(vFrom, vTo);
  }
}

export function requireDAG(adj: AdjacencyList): void {
  adj.depthFirstSearch(ESearchDirection.Outputs, new _DFSCircleDetector());
}

export function isDAG(adj: AdjacencyList): boolean {
  try {
    requireDAG(adj);
    return true;
  } catch (e: unknown) {
    if (e instanceof NotDAGError) {
      return false;
    } else {
      throw e;
    }
  }
}
